import React from "react";
import { useTranslation } from "@lib/i18n";
import { node, bool, func } from "prop-types";

import Typography from "@components/shared/Typography";
import SimpleButton from "@components/shared/SimpleButton";

const EditableContainer = ({
  form,
  isDisabled = false,
  isEditing,
  onChange,
  summary,
  text,
  title,
}) => {
  const { t } = useTranslation();

  const onCancelButtonClick = () => {
    onChange(false);
  };

  const onModifyButtonClick = () => {
    onChange(true);
  };

  return (
    <div className="p-1">
      <Typography className="text-left font-semibold mt-4">{title}</Typography>
      {isEditing ? (
        <div className="flex flex-col items-center">
          {text && (
            <Typography className="text-left text-sm w-full mt-4">
              {text}
            </Typography>
          )}
          {form}
          <SimpleButton className="m-0 pb-4 mb-4" onClick={onCancelButtonClick}>
            {t("myDetails.inputs.cancel")}
          </SimpleButton>
        </div>
      ) : (
        <div className="text-xs">
          {summary}

          {!isDisabled && (
            <SimpleButton
              className="m-0 mb-4 px-0 pb-2"
              withArrow
              onClick={onModifyButtonClick}
            >
              {t("general.modify")}
            </SimpleButton>
          )}
        </div>
      )}
    </div>
  );
};

EditableContainer.propTypes = {
  form: node,
  isDisabled: bool,
  isEditing: bool,
  onChange: func,
  summary: node.isRequired,
  text: node,
  title: node.isRequired,
};

export default EditableContainer;
